import { render, staticRenderFns } from "./courseLearning.vue?vue&type=template&id=5106867b&scoped=true"
import script from "./courseLearning.vue?vue&type=script&lang=js"
export * from "./courseLearning.vue?vue&type=script&lang=js"
import style0 from "./courseLearning.vue?vue&type=style&index=0&id=5106867b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106867b",
  null
  
)

export default component.exports